const _import = require('./_import_' + process.env.NODE_ENV);

export default [
  // vip套餐支付页面
  {
    path: '/pay',
    name: 'pay',
    component: _import('other/pay')
  },
  // vip套餐选择页面
  {
    path: '/vip-list',
    name: 'vipList',
    component: _import('other/vip-list')
  }
];



// WEBPACK FOOTER //
// ./src/router/other.router.js